_ = require('lodash')
moment = require('moment')

GroupEventRankCtrl = ($scope, $translate, $filter, flash, $location, groupEventService, detailData) ->
  angular.element(document.body).css 'min-width', 0
  pageSize = 4
  $scope.lstUserRank = []
  $scope.currentPage = 0
  $scope.groupAdmin = false
  $scope.eventOwner = detailData.eventDetail.owner
  $scope.isLoading = false
  $scope.noResults = true
  $scope.eventDetail = detailData.eventDetail
  $scope.groupDetail = detailData.groupDetail
  $scope.rankingDatas = [
      {type:'avg_shot', name: $filter('translate')('_GROUP_EVENT.AVG_SCORE_RANK')}
      {type:'avg_putt', name: $filter('translate')('_GROUP_EVENT.AVG_PUTT_RANK')}
      {type:'rat_par_on', name: $filter('translate')('_GROUP_EVENT.PER_ON_RATE_RANK')}
      {type:'rat_birdie', name: $filter('translate')('_GROUP_EVENT.BIRDIE_RATE_RANK')}
      {type:'rat_par', name: $filter('translate')('_GROUP_EVENT.PER_RATE_RANK')}
  ]

  hash = $location.hash()
  isExist = false
  for obj, i in $scope.rankingDatas
    if obj.type == hash
      isExist = true
      break
  if !isExist
    hash = 'avg_shot'
  $scope.ranking = {
    type: hash
  }

  groupEventService.checkJoinGroup($scope.groupDetail.id).then (data) ->

    if data.role == "admin"
      $scope.groupAdmin = true


  $scope.loadMore = ->
    $scope.isLoading = true
    $scope.currentPage++
    oderText = ""
    if $scope.ranking.type == 'avg_shot' || $scope.ranking.type == 'avg_putt'
      oderText = "asc"
    else
      oderText = "desc"
    params =
      id : $scope.eventDetail.id
      page : $scope.currentPage
      page_size : pageSize
      sort : $scope.ranking.type
      order : oderText
    groupEventService.listEventRanking(params)
      .then (data) ->
        $scope.lstUserRank = _.union($scope.lstUserRank , data.users)
        $scope.totalPages = data.total_pages
        $scope.noResults = $scope.lstUserRank.length is 0
      .finally ->
        $scope.isLoading = false

  $scope.chooseRanking = (ranking) ->
    url = "/group-event/"+ $scope.eventDetail.id + "/ranking#"+ranking
    $location.url(url)

    # $scope.ranking.type = ranking
    # $scope.isLoading = true
    # $scope.currentPage = 1
    # oderText = ""
    # if ranking == 'avg_shot' || ranking == 'avg_putt'
    #   oderText = "asc"
    # else
    #   oderText = "desc"
    # params =
    #   id : $scope.eventDetail.id
    #   page : $scope.currentPage
    #   page_size : pageSize
    #   sort : $scope.ranking.type
    #   order : oderText
    # groupEventService.listEventRanking(params)
    #   .then (data) ->
    #     $scope.lstUserRank = data.users
    #     $scope.totalPages = data.total_pages
    #     $scope.noResults = $scope.lstUserRank.length is 0
    #   .finally ->
    #     $scope.isLoading = false

  $scope.hasMore = ->
    $scope.noResults == false && $scope.currentPage isnt $scope.totalPages

  $scope.gotoTimelineTab = ->
    url = "/groups/"+ $scope.groupDetail.id + "#timeline"
    $location.url(url)

  $scope.gotoEventTab = ->
    url = "/groups/"+ $scope.groupDetail.id + "#event"
    $location.url(url)

  $scope.gotoRankTab = ->
    url = "/groups/"+ $scope.groupDetail.id + "#rank"
    $location.url(url)

  $scope.gotoEditEventDetail = ->
    url = "/group-event/"+$scope.eventDetail.id+"/edit"
    $location.path(url)

  $scope.gotoAnalysisEvent = (event_id, user_id) ->
    url = "/analysis-event/#{event_id}?user_id=#{user_id}"
    $location.url(url)

  $scope.displayImageRanking = (number) ->
    switch number
      when 1 then 'ranking-one'
      when 2 then 'ranking-two'
      when 3 then 'ranking-three'
      else 'ranking-over-three'

  $scope.displayUserName = (fName , lName) ->
    fName = fName ? ''
    lName = lName ? ''
    if fName + lName == ''
      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')

    if /^ja/i.test $translate.preferredLanguage()
      return lName + " " + fName
    return fName + " " + lName

  $scope.displayPeriod = (startTime, endTime) ->
    reText = " "
    if !startTime && !endTime
      return reText
    reText += $scope.displayDateByLang(startTime)
    reText += "~"
    reText += $scope.displayDateByLang(endTime)
    reText

  $scope.displayDateByLang = (time) ->
    if !time
      return ""
    d = moment(time)
    formatText = 'YYYY-MM-DD(ddd)'
    if /^ja/i.test $translate.preferredLanguage()
      formatText = 'LL(ddd)'
      moment.locale('ja')
    d.format(formatText)

  $scope.displayParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  $scope.displayNoParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  $scope.gotoSubmit = ->
    $location.path('/group-event/'+ $scope.eventDetail.id + '/scorecards')

  $scope.handleTextOfAvatar = (user) ->
    $avatarElement = $(".avatar-for-#{user.id} .avatar-image-text:not(.is-small)")
    if user.display_text_avatar.length == 1
      $avatarElement.removeClass('two-characters')
      $avatarElement.addClass('one-character')
    else
      $avatarElement.removeClass('one-character')
      $avatarElement.addClass('two-characters')
    user.display_text_avatar

  $scope.handleAvatarColor = (user) ->
    user.avatar_url.indexOf('avatar_color') > -1

  $scope.displayNumber = (number) ->
    if not angular.isNumber(number)
      return number
    $filter('number')(number , 2)

  $scope.$watch('lstUserRank' , () ->
    if $scope.currentPage <= 1
      return
    $("html, body").animate({ scrollTop:$(document).height()}, "slow")
  , false)

  $scope.loadMore()

GroupEventRankCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  'flash'
  '$location'
  'groupEventService'
  'detailData'
]

module.exports = GroupEventRankCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-rank-controller.coffee